import React from 'react';
import {Card, Footer, Header, TermsContent, PrivacyContent} from "stories";
import {FooterChildren, HeaderChildren} from "../../auth/auth_views";
import {Col, Container, Row} from "react-bootstrap";
import AuthLayout from "../../../layouts/authLayout/AuthLayout";

export const Terms = ({type}) => {
    return (
        <AuthLayout headerSpacing>
            <Header>
                <HeaderChildren linkedTo={'/sign-up'}/>
            </Header>
            <Container fluid>
                <Row>
                    <Col md={{span: 6, offset: 3}} className={'my-4'}>
                        <Card>
                            {
                                type === 'terms' ? <TermsContent /> : <PrivacyContent />
                            }
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Footer>
                <FooterChildren />
            </Footer>
        </AuthLayout>
    );
};